import auth  from './auth';
import users  from './users';
import brand from './brand';
import devicetype from './devicetype';
import network from './network';
import attributes from './attributes';
import adpoint from './adpoint';
import event from './event';
import campaign from './campaign';
import assets from './assets';
import xxenttxx from './xxenttxx';
import networkowner from './networkowner';
import brandrep from './brandrep';
import location from './location';
import notification from './notification';
import cluster from './cluster';
import role from './role';
import audience from './audience';
import mediaowner from './mediaowner';
import mediacategory from './mediacategory';
import mediachannel from './mediachannel';
import mediaplacement from './mediaplacement';

import {  srvApi, srvApiNoAuth, PATH, getAssetUrl }  from './endpoints';

const api = {
    auth,
    users,
    brand,
    brandrep,
    devicetype,
    network,
    attributes,
    adpoint,
    event,
    campaign,
    assets,
    networkowner,
    location,
    role,
    notification,
    cluster,
    xxenttxx,
    audience,
    mediaowner,
    mediacategory,
    mediachannel,
    mediaplacement
};

export {api, srvApi, srvApiNoAuth, PATH, getAssetUrl};